import { videoAnalytics } from '#/config/constants';
import { clearAssetData } from '#/redux/modules/brightcove/actions';
import {
  setVideoContent,
  setVideoBookmark,
  setBackgroundPlayerFullscreen,
  setExitFromPlayer,
} from '#/redux/modules/appPlayer/actions';
import { setInitialVideoData } from '#/components/ContentLayer/contentLayerUtils';
import { didFirstVideoStarted } from '#/components/ContentLayer/ContentLayer';
import { setHeader } from '#/redux/modules/menu/actions';
import { isWorkstation, isVIZIO } from '#/utils/componentStyleConfig';

import assembleCurrentVideo from '#/utils/assembleCurrentVideo';

const isDeeplinkVideo = () => {
  return /player/.test(window.location.pathname);
};

export const getItemId = (swimlaneId, index) => `${swimlaneId}-ITEM-${index}`;

export const setSwimlaneNav = swimlaneNav => ({
  ...swimlaneNav,
  forwardFocus: getItemId(swimlaneNav.id, 0),
  useLastFocus: true,
});

export const onVideoTileClick = (
  containerIds,
  dispatch,
  fromHome = false,
  doBookmark = false,
) => {
  return containerIndex => (item, videoIndex) => {
    if (!isVIZIO()) {
      return initiation => {
        doBookmark && dispatch(setVideoBookmark());
        !fromHome && dispatch(clearAssetData());
        dispatch(
          setVideoContent({
            playlists: containerIds,
            currentPlaylistIndex: containerIndex,
            currentVideoIndex: videoIndex,
            currentVideo: assembleCurrentVideo(item),
            initiation: initiation || videoAnalytics.initiation.AUTO,
            bgBookmarkEnabled: false,
          }),
        );
        if (fromHome && !isWorkstation()) {
          dispatch(setBackgroundPlayerFullscreen(true));
          dispatch(setExitFromPlayer(true));
          dispatch(setHeader(false));
        }
      };
    }
    if (isVIZIO()) {
      return initiation => {
        if (!didFirstVideoStarted() && !isDeeplinkVideo()) {
          setInitialVideoData(
            containerIds,
            containerIndex,
            videoIndex,
            assembleCurrentVideo(item),
            initiation || videoAnalytics.initiation.AUTO,
          );
        } else {
          doBookmark && dispatch(setVideoBookmark());
          !fromHome && dispatch(clearAssetData());
          dispatch(
            setVideoContent({
              playlists: containerIds,
              currentPlaylistIndex: containerIndex,
              currentVideoIndex: videoIndex,
              currentVideo: assembleCurrentVideo(item),
              initiation: initiation || videoAnalytics.initiation.AUTO,
              bgBookmarkEnabled: false,
            }),
          );
        }
      };
    }
  };
};
